/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export const LICENSE_KEY = '<YOUR_LICENSE_KEY>';
export const AI_API_KEY = '<YOUR_AI_API_KEY>';
export const UPLOADCARE_PUBKEY = '<YOUR_UPLOADCARE_PUBKEY>';
export const DOCUMENT_ID = '<YOUR_DOCUMENT_ID>';
export const CLOUD_SERVICES_TOKEN_URL = '<YOUR_CLOUD_SERVICES_TOKEN_URL>';
export const CLOUD_SERVICES_WEBSOCKET_URL = '<YOUR_CLOUD_SERVICES_WEBSOCKET_URL>';
